import LegalShell from "./LegalShell";

export default function PrivacyNotice() {
  return (
    <LegalShell
      eyebrow="Legal · PNC UNIQUE LTD"
      title="Privacy Notice"
      updated="February 2026"
      testid="privacy-page"
    >
      <p>
        This Privacy Notice explains how <strong>PNC UNIQUE LTD</strong> (&quot;PNC&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;) collects,
        uses and safeguards personal data when contractors, supervisors and managers use the
        <strong> PNC Absence Notifications Portal</strong> (the &quot;Portal&quot;). We process personal data in
        accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
      </p>

      <h2>1. Who is the data controller?</h2>
      <p>
        PNC UNIQUE LTD is the data controller for personal data processed through the Portal.
      </p>
      <ul>
        <li>Registered office: Headlands House, 1 Kings Court, Kettering Parkway, Kettering, Northamptonshire, NN15 6WJ</li>
        <li>ICO Registration: <strong>ZB865873</strong></li>
        <li>Contact: <a href="mailto:admin@pncunique.com">admin@pncunique.com</a> · 0333 090 5024</li>
      </ul>

      <h2>2. What personal data we collect</h2>
      <p>Through the Portal we collect and process:</p>
      <ul>
        <li><strong>Identity data</strong> — first name, last name, full name.</li>
        <li><strong>Contact data</strong> — work email address (where held).</li>
        <li><strong>Employment data</strong> — job role, department, assigned supervisor, site.</li>
        <li><strong>Absence data</strong> — dates of absence, absence type (holiday, sick, other), status of the notification, reasons for rejection or cancellation, timestamps and identity of the person who took the decision.</li>
        <li><strong>Technical data</strong> — session tokens, authentication logs and basic device/browser information required to operate the service securely.</li>
      </ul>

      <h2>3. Why we process your data (lawful bases)</h2>
      <ul>
        <li><strong>Contract</strong> (Article 6(1)(b) UK GDPR) — to manage the contractor engagement, including recording absence.</li>
        <li><strong>Legal obligation</strong> (Article 6(1)(c)) — to keep working-time and absence records as required by UK employment law.</li>
        <li><strong>Legitimate interests</strong> (Article 6(1)(f)) — to run the Portal efficiently, prevent misuse, and provide managers with the operational visibility needed to run PNC sites safely.</li>
      </ul>
      <p>
        Where absence data relates to health (for example, sickness absence), we rely on Article 9(2)(b) UK GDPR
        (obligations in the field of employment law) and the associated conditions in the Data Protection Act 2018.
      </p>

      <h2>4. Who we share data with</h2>
      <p>Personal data recorded in the Portal is accessed by:</p>
      <ul>
        <li>Your assigned supervisor (to approve, reject or cancel notifications).</li>
        <li>Site managers and HR (to plan cover and maintain records).</li>
        <li>PNC administrators of the Portal (for user management and support).</li>
      </ul>
      <p>
        We use the following processors under written data-processing agreements:
      </p>
      <ul>
        <li><strong>MongoDB Atlas</strong> — encrypted database hosting (EU region).</li>
        <li><strong>Resend</strong> — transactional email delivery.</li>
        <li><strong>Emergent</strong> — application hosting (Emergent Deploy).</li>
      </ul>
      <p>We do not sell personal data and we do not use it for advertising or profiling.</p>

      <h2>5. International transfers</h2>
      <p>
        Where a processor stores or transmits data outside the UK/EEA, we rely on the UK International Data
        Transfer Agreement (IDTA) or the UK Addendum to the EU Standard Contractual Clauses to safeguard your data.
      </p>

      <h2>6. How long we keep it</h2>
      <p>
        Absence notifications and related audit trails are retained for <strong>six (6) years</strong> after the end of the
        engagement, in line with statutory limitation periods. Authentication logs are retained for
        <strong> 12 months</strong>. See our <a href="/security">Security &amp; Retention</a> policy for full detail.
      </p>

      <h2>7. Your rights</h2>
      <p>Under UK GDPR you have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Ask us to correct inaccurate or incomplete data.</li>
        <li>Ask us to erase data where there is no continuing lawful basis to keep it.</li>
        <li>Restrict or object to certain processing.</li>
        <li>Receive a copy of your data in a portable format.</li>
        <li>Withdraw consent, where processing is based on consent.</li>
      </ul>
      <p>
        To exercise any of these rights, email <a href="mailto:admin@pncunique.com">admin@pncunique.com</a>.
        We will respond within one month.
      </p>

      <h2>8. Complaints</h2>
      <p>
        If you are not satisfied with how we handle your data, you can complain to the UK Information
        Commissioner&apos;s Office at <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">ico.org.uk</a>
        or on 0303 123 1113.
      </p>

      <h2>9. Changes to this notice</h2>
      <p>
        We may update this notice from time to time. The &quot;Last updated&quot; date at the top of the page
        indicates when the notice was last revised.
      </p>
    </LegalShell>
  );
}
